import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Pricing() {
  const tiers = [{
    id: 'pilot',
    label: 'Entry',
    name: 'PILOT',
    price: '$615',
    tagline: 'Get the foundation right. Site, local SEO, phone and AI support.',
    popular: false,
    topFeatures: ['Website Built and Hosted for You', '50 Website Credits Per Month', 'Google Business Profile Setup', 'AI Phone Attendant, 24/7', '1Dash.Pro CRM + 5 Team Seats']
  }, {
    id: 'copilot',
    label: 'Starter',
    name: 'CO-PILOT',
    price: '$1,235',
    tagline: 'Start driving demand. Paid ads, social and content on top.',
    popular: false,
    topFeatures: ['Everything in Pilot', 'Google or Meta Ads Managed for You', 'Up to $3,000/Mo Managed Ad Spend', 'Social Content Created and Posted', '100 Website Credits Per Month']
  }, {
    id: 'autopilot',
    label: 'Growth',
    name: 'AUTOPILOT',
    price: '$2,780',
    tagline: 'Never miss a lead. Dedicated MR line, estimates, full pipelines.',
    popular: true,
    topFeatures: ['Everything in Co-Pilot', 'Dedicated MR Line, 24/7 AI', 'Up to $10,000/Mo Managed Ad Spend', 'Estimates, Invoices and Text-to-Pay', '200 Website Credits Per Month']
  }, {
    id: 'command',
    label: 'Full System',
    name: 'COMMAND CENTER',
    price: '$5,355',
    tagline: 'The whole operation. White-label MISTR and advanced analytics.',
    popular: false,
    topFeatures: ['Everything in Autopilot', 'Personalized / White-Label MISTR', 'Advanced Analytics Dashboard', 'Up to $25,000/Mo Managed Ad Spend', '400 Website Credits + 50 Team Seats']
  }];
  return <>
      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-teal/30 to-transparent" data-id="element-850" data-mp="2rgctvpp843sm" />

      <section className="section-padding bg-section-gradient relative overflow-hidden" data-id="element-851" data-mp="2mi1p3tdscjh9">
        {/* Subtle Ambient Glow Orbs */}
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-teal/5 rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-852" data-mp="315cwdj2xphbk" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-purple/5 rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-853" data-mp="2w9o3tzpc10or" />

        <div className="inner-container relative z-10" data-id="element-854" data-mp="23jpb9ubxilfc">
          <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-855" data-mp="23l0cbmdzpf2r">
            <span className="text-cyan-400 text-sm font-poppins font-bold uppercase tracking-widest" data-id="element-856" data-mp="2igy5cvsma3ar">
              Pricing
            </span>
            <h2 className="font-poppins font-extrabold text-4xl md:text-5xl leading-tight mt-4 text-white" data-id="element-857" data-mp="2djg3tqgxiqcs">
              Pick the tier that fits{' '}
              <span className="text-cyan-400" data-id="element-858" data-mp="3ovgytn4dzb0z">where you are.</span>
            </h2>
            <p className="text-steel text-lg mt-6" data-id="element-859" data-mp="a42rp0cwqnv">
              Every plan = MindStream.ing — your business, running itself.
            </p>
            <p className="text-steel/70 text-sm mt-4" data-id="element-860" data-mp="57dqn083ku9l">
              White Glove Onboarding $997, includes a real website build. 3-month
              minimum term.
            </p>
          </div>

          <div className="grid lg:grid-cols-4 gap-6 md:gap-8 max-w-[1400px] mx-auto" data-id="element-861" data-mp="3rgyfik4fbjks">
            {tiers.map((tier, i) => <motion.div key={tier.id} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1,
            duration: 0.5
          }} className={`relative bg-[#0F1D3A] border rounded-2xl p-8 flex flex-col h-full ${tier.popular ? 'border-cyan-400 ring-2 ring-cyan-400 shadow-[0_0_60px_rgba(6,182,212,0.3)] lg:-translate-y-4' : 'border-white/10'}`} data-id="element-862" data-mp="nzyeg38xw96j" data-mpi={i}>
                {tier.popular && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-cyan-400 text-[#0F1D3A] px-4 py-1 rounded-full text-xs font-bold tracking-wider uppercase whitespace-nowrap" data-id="element-863" data-mp="35adu3vsjff1f">
                    Most Popular
                  </div>}

                <div className="mb-8 flex-1" data-id="element-864" data-mp="3syx7gpqg2i0d">
                  <span className="text-steel text-xs font-bold tracking-wider uppercase mb-2 block" data-id="element-865" data-mp="3t0866b518zkm">
                    {tier.label}
                  </span>
                  <h3 className="font-poppins font-extrabold text-2xl text-white mb-4" data-id="element-866" data-mp="3k6v9cy3uldt9">
                    {tier.name}
                  </h3>
                  <div className="flex items-baseline gap-1 mb-4" data-id="element-867" data-mp="kkoirsr1mbdh">
                    <span className="text-5xl font-poppins font-extrabold text-white" data-id="element-868" data-mp="fs54etkj7c7m">
                      {tier.price}
                    </span>
                    <span className="text-steel font-medium" data-id="element-869" data-mp="1yh7zhkyq9lfv">/mo</span>
                  </div>
                  <p className="text-steel text-sm leading-relaxed min-h-[40px]" data-id="element-870" data-mp="23ehwblog4zdq">
                    {tier.tagline}
                  </p>
                </div>

                <div className="h-px bg-white/10 w-full mb-8" data-id="element-871" data-mp="2cf68sby6yroi" />

                <div className="flex-1 mb-8" data-id="element-872" data-mp="2he0qtboc4c7k">
                  <ul className="space-y-3" data-id="element-873" data-mp="2hd7tf1b9mz23">
                    {tier.topFeatures.map((feat, idx) => <li key={idx} className="flex items-start gap-3 text-sm text-steel" data-id="element-874" data-mp="2mbj41e9dxdld" data-mpi={idx}>
                        <Check size={16} className="text-cyan-400 shrink-0 mt-0.5" data-id="element-875" data-mp="2v5xff5qso3z7" />
                        <span data-id="element-876" data-mp="302e6o8taiygi">{feat}</span>
                      </li>)}
                  </ul>
                </div>

                <Link to="/pricing" className={`w-full py-4 rounded-lg font-poppins font-semibold transition-all text-center block ${tier.popular ? 'bg-cyan-400 text-[#0F1D3A] hover:bg-cyan-300 shadow-[0_0_20px_rgba(6,182,212,0.4)]' : 'bg-white/10 text-white hover:bg-white/20'}`} data-id="element-877" data-mp="150subpp3ab0r">
                  See Full Details
                </Link>
              </motion.div>)}
          </div>

          <div className="text-center mt-12" data-id="element-878" data-mp="1nq0jwqo7p88m">
            <Link to="/pricing" className="text-cyan-400 hover:text-cyan-300 font-semibold inline-flex items-center gap-2" data-id="element-879" data-mp="1jqrq5lt69ad2">
              Compare all features and tiers →
            </Link>
          </div>
        </div>
      </section>
    </>;
}